import { createStorage } from '@aviata/storage';
import { lastSearchLib } from './lib';
import type { LastSearch } from './types';

const storage = createStorage(localStorage);

/**
 * The model that saves and retrieves search data to/from localStorage
 *
 * @param storageKeyName - Key to store info about last search. It should be unique for different histories.
 *
 * Since data is stored on client side we can't change the key without migration.
 * In case you need to change structure of data that is stored in localStorage you need to use new version of key
 * and, if necessary, migrate old data to new format. Otherwise there might be errors on client side with old data format
 *
 * @example
 *
 * ```js
 * const lastSearchHistory = useLastSearchHistory('freedom-avia:search-history-v1');
 * const newFormatLastSearchHistory = useLastSearchHistory('freedom-avia:search-history-v1', () => { ... });
 * const multiCityLastSearchHistory = useLastSearchHistory('freedom-avia:multi-city-search-history-v1');
 * ```
 */
export const useLastSearchHistory = (storageKeyName: string) => {
  const saveSearchParams = ({
    routes,
    passengers,
    cabinClass,
    isYouth,
  }: LastSearch) => {
    storage.stringify(storageKeyName, {
      routes,
      passengers,
      cabinClass,
      isYouth,
    });
  };

  function getSavedSearchParams() {
    const lastSearch = storage.parse(storageKeyName);

    if (lastSearchLib.isLastSearch(lastSearch)) {
      return lastSearchLib.getValidatedLastSearch(lastSearch);
    }
  }

  return {
    saveSearchParams,
    getSavedSearchParams,
  };
};
